import { BID_STRATEGY, BID_STRATEGY_PER_AFFILIATE } from './index';

export const bidStrategyPerAffiliateValueCSVGetter = data =>
    data[BID_STRATEGY_PER_AFFILIATE.field] || data[BID_STRATEGY.field];

export const bidStrategyPerAffiliateValueGetter = params => bidStrategyPerAffiliateValueCSVGetter(params.data);
